import React, { useState } from 'react';
import { Play, X, Award } from 'lucide-react';
import { mockData } from '../mock';

const FeaturedWork = () => {
  const [selectedFilm, setSelectedFilm] = useState(null);

  return (
    <section className="bg-gradient-to-b from-black via-gray-950 to-black py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-400 to-amber-600">
              Featured Work
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Award-winning films that showcase the art of cinematic storytelling
          </p>
        </div>

        {/* Films Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {mockData.featuredFilms.map((film) => (
            <div
              key={film.id}
              className="group relative overflow-hidden rounded-lg bg-gray-900 cursor-pointer transform transition-all duration-500 hover:scale-105"
              onClick={() => setSelectedFilm(film)}
            >
              {/* Thumbnail */}
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={film.thumbnail}
                  alt={film.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
                
                {/* Play Button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-20 h-20 rounded-full bg-amber-400/20 backdrop-blur-sm flex items-center justify-center transform transition-all duration-300 group-hover:scale-110 group-hover:bg-amber-400/30">
                    <Play className="text-amber-400 ml-1" size={32} fill="currentColor" />
                  </div>
                </div>

                {/* Award Badge */}
                {film.awards && (
                  <div className="absolute top-4 right-4 bg-amber-400/90 backdrop-blur-sm px-3 py-1 rounded-full flex items-center space-x-1">
                    <Award size={14} className="text-black" />
                    <span className="text-xs font-semibold text-black uppercase tracking-wide">Award Winner</span>
                  </div>
                )}
              </div>

              {/* Film Info */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-amber-400 transition-colors">
                  {film.title}
                </h3>
                <p className="text-amber-400 text-sm uppercase tracking-wider mb-3">
                  {film.platform}
                </p>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {film.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Video Modal */}
      {selectedFilm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-md p-6 animate-fade-in">
          <button
            onClick={() => setSelectedFilm(null)}
            className="absolute top-6 right-6 text-white hover:text-amber-400 transition-colors z-50"
            aria-label="Close modal"
          >
            <X size={32} />
          </button>
          
          <div className="w-full max-w-6xl">
            <div className="aspect-video w-full rounded-lg overflow-hidden shadow-2xl">
              <iframe
                src={`${selectedFilm.embedUrl}?autoplay=1`}
                className="w-full h-full"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title={selectedFilm.title}
              />
            </div>
            <div className="mt-6 text-center">
              <h3 className="text-3xl font-bold text-white mb-2">{selectedFilm.title}</h3>
              <p className="text-amber-400 uppercase tracking-wider">{selectedFilm.platform}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default FeaturedWork;